module.exports = __webpack_public_path__ + "img/index.5166c5ce.jpg";